import * as React from "react";
const SplashLoadingScreen: React.FC<any> = props => {
  return (
    <div className="splashFull">
      <a rel="dofollow" href="#home">
        <img
          src="/images/logo.svg"
          className="splashLogo"
          alt="Teatr Horzycy Logo"
        />
      </a>
      <p className="mt-5">Ładowanie...</p>
    </div>
  );
};

export default SplashLoadingScreen;
